import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Github } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { LOGO_URL } from "@/lib/brand";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="relative bg-[#0A192F] text-slate-300 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <Link to="/" className="inline-block" data-testid="footer-logo">
              <img src={LOGO_URL} alt="X10 Management" className="h-24 w-auto" />
            </Link>
            <p className="mt-6 text-slate-300 leading-relaxed max-w-md">{t("footer.tagline")}</p>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Linkedin, label: "LinkedIn" },
                { Icon: Twitter, label: "Twitter" },
                { Icon: Github, label: "GitHub" },
              ].map(({ Icon, label }) => (
                <a key={label} href="#" data-testid={`social-${label.toLowerCase()}`} aria-label={label} className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white hover:text-[#0A192F] transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-[#93C5FD] font-semibold mb-5">{t("footer.nav")}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="/#services" className="hover:text-white transition-colors">{t("nav.services")}</a></li>
              <li><a href="/#about" className="hover:text-white transition-colors">{t("nav.about")}</a></li>
              <li><a href="/#team" className="hover:text-white transition-colors">{t("nav.team")}</a></li>
              <li><a href="/#insights" className="hover:text-white transition-colors">{t("nav.news")}</a></li>
              <li><a href="/#contact" className="hover:text-white transition-colors">{t("nav.contact")}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-[#93C5FD] font-semibold mb-5">{t("footer.legal")}</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/impressum" data-testid="legal-imprint" className="hover:text-white transition-colors">{t("footer.legalLinks.imprint")}</Link></li>
              <li><Link to="/datenschutz" data-testid="legal-privacy" className="hover:text-white transition-colors">{t("footer.legalLinks.privacy")}</Link></li>
              <li><Link to="/agb" data-testid="legal-terms" className="hover:text-white transition-colors">{t("footer.legalLinks.terms")}</Link></li>
              <li><Link to="/datenschutz" className="hover:text-white transition-colors">{t("footer.legalLinks.cookies")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[#93C5FD] font-semibold mb-5">{t("footer.contact")}</div>
            <div className="text-sm text-slate-300 space-y-2">
              <div>Herner Str. 299</div>
              <div>44809 Bochum</div>
              <a href="mailto:kontakt@x10management.de" className="block hover:text-white transition-colors">kontakt@x10management.de</a>
              <a href="tel:+4923460550" className="block hover:text-white transition-colors">+49 234 6055 0</a>
            </div>
          </div>
        </div>

        <div className="pt-10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} X10 Management GmbH. {t("footer.rights")}</div>
          <div className="uppercase tracking-[0.2em]">{t("footer.madeIn")}</div>
        </div>
      </div>
    </footer>
  );
}
